import api from './api';

const importantDatesService = {
  getImportantDates: async () => {
    const response = await api.get('/api/v1/important-dates/');
    return response.data;
  },
};

export default importantDatesService;
